import { render, staticRenderFns } from "./scene.vue?vue&type=template&id=f30bccf2"
import script from "./scene.vue?vue&type=script&lang=js"
export * from "./scene.vue?vue&type=script&lang=js"
import style0 from "./scene.vue?vue&type=style&index=0&id=f30bccf2&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports